import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "payment-requests-balance-widget" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "payment-requests-balance-widget__wallet",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, "Баланс", -1)
const _hoisted_4 = { class: "content__value" }
const _hoisted_5 = { class: "payment-requests-balance-widget__actions" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3 3v5h5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 7v5l4 2" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 5v14" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_icon_button = _resolveComponent("bs-icon-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "payment-requests-balance-widget__content",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOpenHistory && _ctx.onOpenHistory(...args)))
    }, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Загрузка...")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.formatPriceToTenge(_ctx.balance, { withDecimals: true })), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_bs_icon_button, {
        type: "button",
        color: "transparent-blue",
        disabled: _ctx.loading,
        onClick: _ctx.onOpenHistory
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_bs_icon_button, {
        type: "button",
        color: "transparent-blue",
        disabled: _ctx.loading,
        onClick: _ctx.onTopUp
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}